// config.js
const BASE_URL = 'https://task-monitoring.com';
export default BASE_URL;
